import { FC, ReactNode } from 'react';
import { MainContainer, MainTitle } from './styles';

/**
 * Reusable component to wrap the content of main pages.
 */
export const MainContainerWrapper: FC<{
  title?: string;
  children?: ReactNode;
  maxWidth?: string;
  sidePadding?: boolean;
}> = ({ title, children, maxWidth, sidePadding = true }) => (
  <MainContainer $maxWidth={maxWidth} $sidePadding={sidePadding}>
    {title && <MainTitle>{title}</MainTitle>}
    {children}
  </MainContainer>
);
